import React from 'react';
import styles from './BookingReservationDetail.module.css';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

interface IBookingReservationDetail {
  bookingLabel: string;
  bookingValue: string | number;
  bookingValueTextStyle: string;
}

const BookingReservationDetail = ({
  bookingLabel,
  bookingValue,
  bookingValueTextStyle
}: IBookingReservationDetail) => {
  const { t } = useTranslation();
  const bookingValDivTextStyle = classNames(styles.valDiv, bookingValueTextStyle);
  return (
    <div className={styles.reservationBookingDetailContainer}>
      <div className={styles.labelDiv} data-testid="reservationBookingDetailLabelDiv">
        <p>
          <strong>{t(`${bookingLabel}`)}</strong>
        </p>
      </div>
      <div className={bookingValDivTextStyle} data-testid="reservationValueDiv">
        <p>{bookingValue}</p>
      </div>
    </div>
  );
};

export default BookingReservationDetail;
